import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {VendorDocumentTitle} from 'src/pages/Modules/Vendors/shared/vendorHelpers';
import {VendorForm} from 'src/pages/Modules/Vendors/shared/VendorForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const VendorCreatePage = () => {
  useSetDocumentTitle(VendorDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Vendors}>
      <VendorForm mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorsCreate(),
  element: <VendorCreatePage />,
  module: ModuleEnum.Vendors,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default VendorCreatePage;
